(() => {
  function initMangaRequest() {
    const widget = document.getElementById('manga-request-widget');
    if (!widget || widget.dataset.initialized) return;
    widget.dataset.initialized = 'true';

    const tab = widget.querySelector('.manga-request-tab');
    const close = widget.querySelector('.manga-request-close');
    const drawer = widget.querySelector('.manga-request-drawer');
    if (!tab || !close || !drawer) return;

    drawer.setAttribute('role', 'dialog');
    drawer.setAttribute('aria-modal', 'true');
    drawer.setAttribute('aria-label', 'Request a manga');
    drawer.inert = true;

    const backdrop = document.createElement('div');
    backdrop.className = 'manga-request-backdrop';
    backdrop.hidden = true;
    widget.prepend(backdrop);

    let previousFocus;

    function openDrawer() {
      // Close What's New first.
      document.getElementById('wn-close')?.click();

      previousFocus = document.activeElement;
      widget.classList.add('is-open');
      document.documentElement.classList.add('manga-request-open');
      tab.setAttribute('aria-expanded', 'true');
      drawer.setAttribute('aria-hidden', 'false');
      drawer.inert = false;
      backdrop.hidden = false;
      close.focus({ preventScroll: true });
    }

    function closeDrawer(restoreFocus = true) {
      widget.classList.remove('is-open');
      document.documentElement.classList.remove('manga-request-open');
      tab.setAttribute('aria-expanded', 'false');
      drawer.setAttribute('aria-hidden', 'true');
      drawer.inert = true;
      backdrop.hidden = true;

      if (restoreFocus && previousFocus?.isConnected) {
        previousFocus.focus({ preventScroll: true });
      }
    }

    tab.addEventListener('click', openDrawer);
    close.addEventListener('click', () => closeDrawer());
    backdrop.addEventListener('click', () => closeDrawer());

    document.getElementById('wn-tab')?.addEventListener(
      'click',
      () => closeDrawer(false)
    );

    drawer.addEventListener('keydown', (event) => {
      if (event.key !== 'Tab') return;

      const focusable = drawer.querySelectorAll(
        'button:not([disabled]), input:not([disabled]):not([type="hidden"]), textarea:not([disabled]), select:not([disabled]), a[href]'
      );

      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (!first || !last) return;

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && widget.classList.contains('is-open')) {
        closeDrawer();
      }
    });
    
    if (widget.querySelector('.manga-request-success, .manga-request-error')) {
      openDrawer();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMangaRequest, {
      once: true
    });
  } else {
    initMangaRequest();
  }
})();
